export default __webpack_public_path__ + "static/media/maayan-adam.c66dff61.png";